module.exports = __webpack_public_path__ + "img/GuiadelaSaludPR.com.4fff3850.svg";